const getSettings = (rootState) => rootState.ws.integration.settings;

export default getSettings;
